module.exports = __webpack_public_path__ + "assets/seeline.396d0c17.svg";